





















import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/OHeader.vue";
import LoginForm from "@/components/forms/LoginForm.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    LoginForm,
    Footer,
  },
})
export default class OLogin extends Vue {}
